<template>
  <div class="issue">

    <div class="row no-gutters" v-if="smallMode">
      <div class="col-auto mb-3" :class="{'hidden-md-up': smallMode}"><img class="issue-cover" v-bind:src="coverUrl" v-if="coverUrl"/></div>
      <div class="col" :class="{'hidden-md-up': smallMode}">
        <div class="row">
          <div v-if="!hideType" class="articleType col-sm-12">{{ issue.article_type ? issue.article_type.name : ''  }}</div>
          <div class="title col-sm-12" v-html="issue.title">{{ issue.title }}</div>
        </div>
      </div>
    </div>

    <div v-if="!hideType" class="articleType" :class="{'hidden-sm-down': smallMode}">{{ issue.article_type ? issue.article_type.name : ''  }}</div>
    <div class="title" v-html="issue.title" :class="{'hidden-sm-down': smallMode}">{{ issue.title }}</div>
    <div class="row mb-4 no-gutters">
      <div class="col-md-auto" :class="{'hidden-sm-down': smallMode}"><img class="issue-cover mb-3" v-bind:src="coverUrl" v-if="coverUrl"/></div>
      <div class="col-md col-sm-12">
        <div class="doi">DOI: <span>{{ issue.ids ? issue.ids.doi : ''  }}</span>&nbsp;&nbsp;
                        pp {{issue.page_start}}-{{issue.page_end}}
        </div>
        <div :class="{'hidden-sm-down': smallMode}">
          <issue-authors v-bind:authors="issue.authors"></issue-authors>
        </div>
        <article-quick-links :article="issue"></article-quick-links>
        <div class="abstract" v-if="issue.abstract" :class="{ hide: !isAbstractShow }" v-html="issue.abstract"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import ArticleQuickLinks from '@/components/shared/ArticleQuickLinksComponent'
  import IssueAuthors from '@/components/shared/IssueAuthorsComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  export default {
    components: {
      ArticleQuickLinks,
      IssueAuthors
    },
    name: 'condensed-issue',
    mixins: [ UtilityMixin ],
    props: ['issue', 'smallMode', 'hideType'],
    computed: {
      coverUrl () {
        return (this.issue.issue && this.issue.issue.cover) ? this.issue.issue.optimized_urls.small : false
      }
    },
    methods: {
      toggleAbstract () {
        this.isAbstractShow = !this.isAbstractShow
      }
    },
    data () {
      return {
        isAbstractShow: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .issue {
    margin-bottom: 30px;
    margin-top: 30px;
    &:not(:last-child) {
      border-bottom: 1px solid $devider;
    }
    .table {
      display: table;
      .table-cell {
        display: table-cell;
        vertical-align: top;
      }
    }

    .articleType {
      font-family: 'Open Sans', sans-serif;
      font-size: 12px;
      line-height: 1.42;
      text-align: left;
      color: $primary-color;
      opacity: 0.6;
      margin-bottom: 7.5px;
    }
    .title {
      font-family: 'Merriweather', serif;
      font-size: 24px;
      font-weight: 300;
      line-height: 1.25;
      text-align: left;
      color: $accent-color-1;
      margin-bottom: $spacing-large;
    }
    .issue-cover {
      margin-right: 12px;
      width: 100px;
      &.mb-3 {
        @media (min-width: $breakpoint-md) {
          margin-bottom: 0 !important;
        }
      }
    }
    .doi {
      font-size: 12px;
      line-height: 1.42;
      text-align: left;
      color: $accent-color-3;
      span {
        color: $accent-color-1;
        text-decoration: underline;
      }
    }
    .authors {
      font-family: 'Open Sans', sans-serif;
      font-size: 14px;
      line-height: 1.21;
      text-align: left;
      color: $accent-color-2;
      margin: 15px 0;
      span {
        text-decoration: underline;
      }
    }
    .abstract {
      clear: both;
      padding-top: 20px;
      max-height: 100vh;
      overflow: hidden;
      transition: max-height 200ms;
      &.hide {
        max-height: 0;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// CondensedIssueComponent.vue?1766fd49